export default {"src":"/_next/static/media/block-bell-notification.2a16e4e7.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};